// extracted by mini-css-extract-plugin
export default {"disclamer":"Disclamer_disclamer__egjmm"};